export default __webpack_public_path__ + "static/media/pelota-americano.1a721f9e.png";